import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import { Layout } from '@components/organisms';
import { Home } from '@pages';

const App = () => {
  return (
    <Routes>
      {/* <Route element={<Layout />}> */}
      <Route index element={<Home />} />
      <Route path="home" element={<Home />} />
      {/* </Route> */}
      <Route path="*" element={<h1>404 Not Found</h1>} />
    </Routes>
  );
};

export default App;
